export default __webpack_public_path__ + "static/media/faro5_ret-blackwhite-e1578154560997.981abb7c.png";